module.exports = ".paper {\n  display: table-cell;\n  vertical-align: top;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\n.left-arrow, .right-arrow {\n  display: table-cell;\n  width: 25px;\n  padding: 0px 3px;\n  vertical-align: middle;\n}\n\n.left-arrow img, .right-arrow img {\n  cursor: pointer;\n}\n\n@media screen and (max-width: 640px) {\n  .left-arrow, .right-arrow {\n    display: none;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cockehsu-catalog.component.css
// module id = ./src/app/cockehsu-catalog.component.css
// module chunks = main